<mat-checkbox class='px-4' color='primary'>
  <ng-content></ng-content>
</mat-checkbox>
